export default __webpack_public_path__ + "static/media/334.462f3a23.gif";